import type { ThemeHint } from '@/store/conversation-types'

/**
 * Coogo's default generation theme follows the same action-blue authority as
 * the Studio shell. Purple remains available only when a user or an admitted
 * design-system preset explicitly selects it.
 */
export const COGO_DEFAULT_PRIMARY_COLOR = '#2563EB'

export function createDefaultStudioThemeHint(): ThemeHint {
  return {
    primaryColor: COGO_DEFAULT_PRIMARY_COLOR,
    style: 'modern clean',
    fontFamily: 'font-sans',
  }
}
